import format from 'date-fns/format'
import numeral from 'numeral'

export default {
  methods: {
    dateFormat(date, date_format) {
      return format(date, date_format || 'YYYY年MM月DD日')
    },
    numberFormat(number, number_format) {
      return numeral(number).format(number_format || '0,0')
    },
    ie10() {
      return window.navigator.userAgent.toLowerCase().indexOf('trident/6') !== -1
    },
    ie11() {
      return window.navigator.userAgent.toLowerCase().indexOf('trident/7') !== -1
    },
    useSvg() {
      return window.navigator.userAgent.toLowerCase().indexOf('trident/7') === -1
          && window.navigator.userAgent.toLowerCase().indexOf('trident/6') === -1
          && window.navigator.userAgent.toLowerCase().indexOf('edge') === -1
    },
    forceCanvas() {
      return window.navigator.userAgent.toLowerCase().indexOf('trident/7') === -1
          && window.navigator.userAgent.toLowerCase().indexOf('trident/6') === -1
    },
  },
}



// WEBPACK FOOTER //
// ./assets/js/helpers.js